import * as api from 'api';
import { actionTypes } from 'redux-resource';
import { SubmissionError } from 'redux-form';

export const createDevice = (device) => (dispatch) => {
  const actionDefaults = {
    resourceType: 'insuranceDevices',
    requestKey: 'create',
    list: 'insuranceDevices',
  };

  dispatch({
    ...actionDefaults,
    type: actionTypes.CREATE_RESOURCES_PENDING,
  });

  return api
    .createInsuranceDevice(device)
    .then((response) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.CREATE_RESOURCES_SUCCEEDED,
        resources: [response.data],
      });
    })
    .catch((err) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.CREATE_RESOURCES_FAILED,
      });

      let messages = err.response
        ? err.response.data
        : { detail: 'Something went wrong' };
      throw new SubmissionError(messages);
    });
};

export const findDevice = (id) => (dispatch) => {
  const actionDefaults = {
    resourceType: 'insuranceDevices',
    requestKey: 'find',
    resources: [id],
  };

  dispatch({
    ...actionDefaults,
    type: actionTypes.READ_RESOURCES_PENDING,
  });

  return api
    .fetchInsuranceDevice(id)
    .then((response) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_SUCCEEDED,
        resources: [response.data],
      });
    })
    .catch((err) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_FAILED,
      });

      let messages = err.response
        ? err.response.data
        : { detail: 'Something went wrong' };
      throw new SubmissionError(messages);
    });
};

export const fetchDeviceByContract = (contract) => (dispatch) => {
  const actionDefaults = {
    resourceType: 'insuranceDevices',
    requestKey: 'all',
  };

  dispatch({
    ...actionDefaults,
    type: actionTypes.READ_RESOURCES_PENDING,
  });

  return api
    .fetchDeviceByContract(contract)
    .then((response) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_SUCCEEDED,
        resources: response.data.results,
      });
    })
    .catch((err) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_FAILED,
      });
    });
};

export const activateDevice = (id) => (dispatch) => {
  const actionDefaults = {
    resourceType: 'insuranceDevices',
    requestKey: 'activateDevice',
    resources: [id],
  };

  dispatch({
    ...actionDefaults,
    type: actionTypes.UPDATE_RESOURCES_PENDING,
  });

  return api
    .activateInsuranceDevice(id)
    .then((response) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.UPDATE_RESOURCES_SUCCEEDED,
        meta: {
          activation: {
            ...response.data,
          },
        },
      });
    })
    .catch((err) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.UPDATE_RESOURCES_FAILED,
      });

      let messages = err.response
        ? err.response.data
        : { detail: 'Something went wrong' };
      throw new SubmissionError(messages);
    });
};

export const cancelDevice = (id, cancel) => (dispatch) => {
  const actionDefaults = {
    resourceType: 'cancelDevices',
    requestKey: 'activateDevice',
    resources: [id],
  };

  dispatch({
    ...actionDefaults,
    type: actionTypes.UPDATE_RESOURCES_PENDING,
  });

  return api
    .cancelInsuranceDevice(id, cancel)
    .then((response) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.UPDATE_RESOURCES_SUCCEEDED,
        meta: {
          cancellation: {
            ...response.data,
          },
        },
      });
    })
    .catch((err) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.UPDATE_RESOURCES_FAILED,
      });

      let messages = err.response
        ? err.response.data
        : { detail: 'Something went wrong' };
      if (messages.detail) {
        throw new SubmissionError({ _error: messages });
      } else if (messages.message || messages.error) {
        throw new SubmissionError({
          _error: messages.message || messages.error,
        });
      } else {
        throw new SubmissionError(messages);
      }
    });
};
